import { BdsGrid, BdsTypo, BdsInputEditable } from 'blip-ds/dist/blip-ds-react';
import React from 'react';
import { Subtitle } from './styles';

interface PageHeaderProps {
  title: string;
  subtitle: string;
  children?: React.ReactNode;
  isEditable?: boolean;
  onTitleEdit?: (newTitle: string) => void;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, children, isEditable = false, onTitleEdit }) => {
  return (
    <BdsGrid gap="2" justifyContent="space-between" alignItems="flex-start">
      <BdsGrid gap={isEditable ? 'none' : '2'} direction="column">
        {isEditable ? (
          <BdsInputEditable
            expand={true}
            value={title}
            onBdsInputEditableSave={(event: CustomEvent) => {
              onTitleEdit?.(event.detail.value);
            }}
          />
        ) : (
          <BdsTypo variant="fs-20" bold="bold" margin={false}>
            {title}
          </BdsTypo>
        )}
        <Subtitle>
          <BdsTypo variant="fs-14">{subtitle}</BdsTypo>
        </Subtitle>
      </BdsGrid>
      {children}
    </BdsGrid>
  );
};

export default PageHeader;
